import type { FaireProductEntity } from "../../entity_types/product";

export const p_79z6w9ma5c: FaireProductEntity = {
  token: "p_79z6w9ma5c",
  type: "product",
  name: "18K Gold Oval Crystal Collar Necklace",
  brandToken: "b_byvu4wr4",
  brandName: "Brenda Grands Waterproof Jewelry",
  imageUrl:
    "https://cdn.faire.com/fastly/2b9d15ae57c4c299cfe642f15c3415c9ba1f4c6d62488a82ae8cb041d891a02d.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/446906b3cee1527ad243f19755bce949656225fe6b84639979eccfeba6237706.png",
    "https://cdn.faire.com/fastly/0de5ce972974064acf8d9e9f59355157cc5a96f630f3ca92a207beb6c95030d4.jpeg",
    "https://cdn.faire.com/fastly/8f0318f24de0441703e267989e7e0e73104972686668bc857b5ec1a70b14b30f.jpeg",
    "https://cdn.faire.com/fastly/97b80b6ab81bf51193eae3dc90d4a831152ca8291909f892154fce3c42c1567f.jpeg",
    "https://cdn.faire.com/fastly/776cc8a38b61bddad734647a9b4db6b4a993b1ff93cb90949e8d7f3f705753de.png",
    "https://cdn.faire.com/fastly/566c8b1f72ec1b5befd78a9543899beca6666a0c2f39e0516b422bd5cd0d5602.png",
    "https://cdn.faire.com/fastly/378fe410950c6e604b0342f1ca0dcc4a1b34574c8a510c9eab5e024bd9f2c6be.jpeg",
    "https://cdn.faire.com/fastly/3a066dc5625c1d04036844d1a792c6e7b6c4dc10802be50c9a422a96da4e4c2f.jpeg",
  ],
  priceDollars: 28,
  description:
    "\n * Water resistant & tarnish-free \n * 18–24K gold layered over solid brass base \n * 5A Premium cubic zirconia - highest grade \n * Protective coating for lasting shine \n * Nickel-free, lead-free & hypoallergenic \n\n\nThe perfect balance of everyday and elevated. Clean, polished, and designed to pull every look together.\n",
  tags: [],
  msrpDollars: 69,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:39.219Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
